import type {
  ComparisonResult,
  LegalIssue,
} from '@/types/document-analysis-types';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface DocumentAnalysisState {
  identifiedIssues: LegalIssue[];
  comparisonResults: ComparisonResult[];
  analysisSummary: string;
  fileName: string;
  fileId: number | null;
  sessionId: string | null;
}

const initialState: DocumentAnalysisState = {
  identifiedIssues: [],
  comparisonResults: [],
  analysisSummary: '',
  fileName: '',
  fileId: null,
  sessionId: null,
};

const documentAnalysisSlice = createSlice({
  name: 'documentAnalysis',
  initialState,
  reducers: {
    setAnalysisResults: (
      state,
      action: PayloadAction<{
        identifiedIssues: LegalIssue[];
        comparisonResults: ComparisonResult[];
        analysisSummary: string;
        fileName: string;
        fileId: number | null;
        sessionId: string | null;
      }>
    ) => {
      state.identifiedIssues = action.payload.identifiedIssues;
      state.comparisonResults = action.payload.comparisonResults;
      state.analysisSummary = action.payload.analysisSummary;
      state.fileName = action.payload.fileName;
      state.fileId = action.payload.fileId;
      state.sessionId = action.payload.sessionId;
    },
    resetAnalysisResults: () => initialState,
  },
});

export const { setAnalysisResults, resetAnalysisResults } =
  documentAnalysisSlice.actions;

// Selectors
export const selectDocumentAnalysisResults = (state: RootState) =>
  state.documentAnalysis;

export const selectHasAnalysisResults = (state: RootState) =>
  state.documentAnalysis.analysisSummary !== '' ||
  state.documentAnalysis.comparisonResults.length > 0;

export default documentAnalysisSlice.reducer;
